//
//
//
//
//
//

import {EventBus} from './../../../events';

export default {
    name: "game-vote",
    props: ['id', 'player', 'team', 'votes'],
    data(){
        return {
            totalVotes: 0,
        }
    },
    mounted() {
        this.totalVotes = this.votes;
    },
    methods: {
        vote() {
            window.Api.get('rugby/game/' + this.id + '/vote/' + this.player + '-' + this.team).then((data) => {
                if( data.success ) {
                    if( data.action === 'increment' ) {
                        this.totalVotes++;
                    } else {
                        this.total--;
                    }

                    EventBus.$emit('vote-player', {
                        team: this.team,
                        votes: this.totalVotes,
                        player: this.player,
                        type: data.action,
                    });
                } else {
                    window.Vue.notify({
                        group: 'default',
                        text: data.message,
                        type: 'error',
                    });
                }
            });
        }
    }
}
